/***
 *
 * Please Do not use this Component.
 */

import styles from "./BadgeElement.module.css";
import { GetFormattedDate } from "../../../utils/dateTime";
import { useIntl } from "react-intl";
import { getALMObject } from "../../../utils/global";
import { Checkbox } from "@adobe/react-spectrum";
import { useState } from "react";

const BadgeElement = (props: any) => {
  const { locale, formatMessage } = useIntl();
  const {
    id,
    loDetails,
    badge,
    dateAchieved,
    badgeAquiredForType,
    badgeTypeName,
    num,
    setNum,
    handleDownloadPdfClick,
    handleDownloadImgClick,
    handleRedirectToCourse,
    redirectUrl,
    onBadgeSelect
  } = props;
  const status = dateAchieved ? true : false;
  const formattedDate = dateAchieved && GetFormattedDate(dateAchieved, locale);
  const [selected, setSelected] = useState(false);

  const BadgeTypeName = (
    <a
      className={`${styles.inline} ${!loDetails.includes('course') && styles.disabled}`}
      tabIndex={0}
      onClick={() => handleRedirectToCourse(redirectUrl, loDetails)}
      aria-label={
        status
          ? badgeTypeName
          : formatMessage(
              { id: "alm.badge.type.notCompleted.label" },
              { badgeTypeName }
            )
      }
    >
      {badgeTypeName}
    </a>
  );

  const handleSelect = () => {
    const newSelected = !selected;
    setSelected(newSelected);

    if (onBadgeSelect) {
      onBadgeSelect({ id, badge }, newSelected);
  }
    if (selected) {
      setNum(num - 1);
    } else {
      setNum(num + 1);
    }
  };

  return (
    <>
    {status ? <div className={styles.itemview}>
      <div className={styles.badgebox}>
        <Checkbox
          UNSAFE_className={styles.checkbox}
          isDisabled={!status}
          excludeFromTabOrder={!status}
          aria-label={formatMessage(
            { id: "alm.badge.checkbox" },
            { badgeName: badge.name }
          )}
          aria-hidden={status ? false : true}
          isSelected={selected}
          onChange={handleSelect}
        />
        <div className={styles.imagecontainer}>
          <img className={styles.image} src={badge.imageUrl} alt={badge.name} />
        </div>
        <div className={styles.containertext}>
          <div className={styles.badgename}>{badge.name}</div>
          <div className={styles.para}>
            {status
              ? <>{BadgeTypeName} {formattedDate}</>
              : formatMessage(
                  { id: "alm.badge.type.notCompleted" },
                  {
                    badgeAquiredForType,
                    badgeTypeName: BadgeTypeName,
                  }
                )}
          </div>
          <div className={styles.badgestatus}>
            {formatMessage({ id: "alm.badge.status" })}
            {status ? (
              <span className={styles.achieved}>
                Completed
              </span>
            ) : (
              <span className={styles.inprogress}>
                {formatMessage({ id: "alm.badge.status.inProgress" })}
              </span>
            )}
          </div>
        </div>
        <div
          className={
            status ? styles.downloadicons : styles.downloadiconsdisabled
          }
        >
          <div className={styles.downloadoptions}>
            <div className={styles.downloadlink}>
              <a
                analytics-training-name={badgeTypeName}
                analytics-training-id={id}
                analytics-download-type="individual"
                analytics-file-type="pdf"
                className={`${styles.blue} btn-certificate-download`}
                tabIndex={status ? 0 : -1}
                onClick={status ? () => handleDownloadPdfClick(id) : undefined}
                aria-label={formatMessage(
                  { id: "alm.badge.downloadPdf" },
                  { badgeName: badge.name }
                )}
                aria-hidden={status ? false : true}
              >
                {formatMessage({ id: "alm.text.pdf" })}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> : ''}
    </>
  );
};

export default BadgeElement;
